

export default {
  components: {
  },
  props: {
    purchaseValue: {
      type: String,
      default: '02'
    }
  },
  data () {
    return {
      bannerInfo: {
        img: {
          '02': '/images/tempLy/purchase_banner_pickup.png',
          '03': '/images/tempLy/purchase_banner_regular.png',
          '04': '/images/tempLy/purchase_banner_mass.png',
          '05': '/images/tempLy/purchase_banner_quick.png'
        },
        text: {
          '02': '매장픽업 이렇게 사용하세요. 배송비 부담없이 간편하게 픽업',
          '03': '정기배송 이렇게 사용하세요. 원하는 날짜에 간편하게 문 앞까지',
          '04': '대량주문 이렇게 사용하세요. 크고 무거운 상품도 바로 집앞으로',
          '05': '오늘배송 이렇게 사용하세요. 지금 주문하면 바로오는 오늘배송'
        },
        link: {
          '02': '/ds/pickupOrder/C119',
          '03': '/ds/fb/C229',
          '04': '/ds/bulkOrder/C116',
          '05': '/ds/quickOrder/C118'
        }
      },
    }
  }
}
